import { Component, OnInit, Input } from '@angular/core';
import { ReportTemplateDesignService, Notifier, MousePoint } from 'src/app/_services/report-template-design.service';
import { ReportDataPlate } from 'src/app/_objects/report-data-plate';
import { FromToDetail, TemplateDataPlate } from 'src/app/_objects/report-template';
import { ElementType } from 'src/app/_objects/element-type';

export class ReportComponentBase {
  public x: number;
  public y: number;
  public width: number;
  public height: number;
}

@Component({
    selector: 'app-report-dataplate-container',
    templateUrl: './report-dataplate.component.html',
    styleUrls: ['./report-dataplate.component.scss'],
    standalone: false
})
export class ReportDataPlateComponent implements OnInit {

  @Input() pageKey: string;
  @Input() dataPlateKey: string;
  @Input() public elementLocation: string;

  reportDataPlate: ReportDataPlate;
  baseDef: TemplateDataPlate;
  sizeUnit: string;
  maxWidth: number;
  maxHeight: number;
  private notifier: Notifier;
  public resizeMarkerSize: number;
  public resizing: boolean;

  constructor(
    public designService: ReportTemplateDesignService
  ) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  ngOnInit() {
    this.notifier = {
      componentName: 'report-dataplate.component',
      ids: { pageId: this.pageKey, elementId: this.dataPlateKey }
    };
    this.reportDataPlate = this.designService.getDataPlate(this.dataPlateKey);
    this.sizeUnit = this.reportDataPlate.getSizeUnit() ?? 'mm';
    this.maxHeight = this.getImageMaxHeight();
    this.maxWidth = this.getImageMaxWidth();
    let elementNavigator = this.designService.navigatorElements
    .filter((x) => x.pageKey == this.pageKey)[0]
    .elementsDetails.filter((y) => y.location == this.elementLocation)[0]
      .elements;

     elementNavigator.filter(x=>x.elementName == ElementType.DataPlate).length > 0
      ? elementNavigator.filter(x=>x.elementName == ElementType.DataPlate)[0].elementData.push({
          id: this.dataPlateKey,
          page: this.pageKey,
          name: this.reportDataPlate.getTitle(),
        })
      : elementNavigator.push({
          elementName: ElementType.DataPlate,
          isVisible: false,
          elementData: [
            {
              id: this.dataPlateKey,
              page: this.pageKey,
              name: this.reportDataPlate.getTitle(),
            },
          ],
        });
  }

  onClick(event: MouseEvent) {
    if (this.reportDataPlate.isSelectable) {
      this.designService.notifySelectElement(this.notifier, this.dataPlateKey, event.ctrlKey);
      event.stopPropagation();
    }
  }

  onDragStart(event: DragEvent) {
    // console.log('ReportDataPlate onDragStart');
    event.dataTransfer.setData('text', this.dataPlateKey);
    event.dataTransfer.effectAllowed = 'move';

    const fromDetail: FromToDetail = {
      location: this.reportDataPlate.getLocation(),
      pageId: this.pageKey
    };
    const dragPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };

    this.designService.notifyBeginDrag(this.notifier, ElementType.DataPlate, fromDetail, dragPoint);
  }

  onDragOver(event: DragEvent) {
    // console.log('ReportDataPlate onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    // console.log('ReportDataPlate onDrop');
    event.preventDefault();
    const template  = {...this.designService.originTemplate};
    template.reportTemplateContent = JSON.stringify(this.designService.getTemplate());
    this.designService.templateForUndo.push(template);
    const dragElemId = event.dataTransfer.getData('text');

    const toDetail: FromToDetail = {
      location: this.reportDataPlate.getLocation(),
      pageId: this.pageKey
    };
    const dropPoint: MousePoint = {
      onElementX: this.reportDataPlate.getLeftPx() + event.offsetX,
      onElementY: this.reportDataPlate.getTopPx() + event.offsetY
    };

    this.designService.notifyDrop(this.notifier, dragElemId, toDetail, dropPoint);

    event.dataTransfer.clearData('text');
    event.stopPropagation();
  }

  getTitleComponentStyle(index: number, position: string){
    this.baseDef = this.reportDataPlate.getBaseDef();

    let style = {};
    style['left'] = `${this.baseDef.imageInfo.title.x}${this.sizeUnit}`;
    style['top'] = `${(position === 'top' ? this.baseDef.imageInfo.title.y : this.maxHeight + this.baseDef.imageInfo.title.y)}${this.sizeUnit}`;
    style[`width.${this.sizeUnit}`] = this.baseDef.imageInfo.title.width / 2;
    style[`height.${this.sizeUnit}`] = this.baseDef.imageInfo.title.height;

    style['color'] = this.reportDataPlate.imageInfoTitleFontColor;
    style['font-size'] = this.reportDataPlate.imageInfoTitleFontSize;
    style['font-family'] = this.reportDataPlate.imageInfoTitleFontFamily;
    style['font-style'] = this.reportDataPlate.imageInfoTitleFontStyle;
    style['font-weight'] = this.reportDataPlate.imageInfoTitleFontWeight;
    style['text-align'] = this.reportDataPlate.imageInfoTitleTextAlign;
    style['vertical-align'] = this.reportDataPlate.imageInfoTitleVerticalAlign;
    style['line-height'] = this.reportDataPlate.imageInfoTitleLineHeight;
    style['background-color'] = this.reportDataPlate.imageInfoTitleBackgroundColor;
    style['border-style'] = this.reportDataPlate.imageInfoTitleBorderStyle;
    style['border-width'] = `${this.reportDataPlate.imageInfoTitleBorderWidth}${this.sizeUnit}`;
    style['border-color'] = this.reportDataPlate.imageInfoTitleBorderColor;

    return style;
  }
  getPictureComponentStyle(index: number, position: string){
    this.baseDef = this.reportDataPlate.getBaseDef();

    let style = {};
    style['position'] = 'absolute';
    style['left'] = `0${this.sizeUnit}`;
    style['top'] = `${(position === 'top' ? this.baseDef.imageInfo.title.height : 0)}${this.sizeUnit}`;
    style[`width.${this.sizeUnit}`] = this.baseDef.imageInfo.image.width;
    style[`height.${this.sizeUnit}`] = this.baseDef.imageInfo.image.height;

    style['border-color'] = 'black';
    style['background-color'] = 'whitesmoke';
    style['text-align'] = 'center';

    return style;
  }
  getDivComponentStyle(index: number){
    const div = this.getComponentBase(index);

    let style = {};
    style['position'] = 'absolute';
    style['left'] = `${div.x}${this.sizeUnit}`;
    style['top'] = `${div.y}${this.sizeUnit}`;
    style[`width.${this.sizeUnit}`] = div.width;
    style[`height.${this.sizeUnit}`] = div.height;

    return style;
  }
  getComponentBase(index: number){
    const div = new ReportComponentBase();
    this.baseDef = this.reportDataPlate.getBaseDef();
    div.width = this.baseDef.imageInfo.width / 2;
    div.height = this.baseDef.imageInfo.height / 2;
    div.x = (index + 2) % 2 === 1 ? div.width : 0;
    div.y = index >= 2 ? div.height : 0;

    return div;
  }
  getImageMaxWidth(){
    this.baseDef = this.reportDataPlate.getBaseDef();
    return this.baseDef.imageInfo.width / 2;
  }
  getImageMaxHeight(){
    this.baseDef = this.reportDataPlate.getBaseDef();
    const titleHeight = (this.baseDef.imageInfo.title.position === 'top' ? this.baseDef.imageInfo.title.height : 0)
      + (this.baseDef.imageInfo.title.position === 'bottom' ? this.baseDef.imageInfo.title.height : 0);
    const height = this.baseDef.imageInfo.height / 2;
    return height - titleHeight;
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + 'px';
  }

  public getTitleResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportDataPlate.getTitleWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportDataPlate.getTitleWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getTitleResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportDataPlate.getTitleHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportDataPlate.getTitleHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getTableResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case 'left':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'center':
        return ((this.reportDataPlate.getImageWidthPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'right':
        return (this.reportDataPlate.getImageWidthPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public getTableResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case 'top':
        return (this.resizeMarkerSize / 2 * -1) + 'px';
      case 'middle':
        return ((this.reportDataPlate.getImageHeightPx() / 2) - (this.resizeMarkerSize / 2)) + 'px';
      case 'bottom':
        return (this.reportDataPlate.getImageHeightPx() - (this.resizeMarkerSize / 2)) + 'px';
      default:
        return '';
    }
  }

  public onResizeMarkerDown(event: MouseEvent, vertical: string, horizontal: string) {
    event.preventDefault();
    this.resizing = true;
    const beginPoint: MousePoint = {
      onElementX: event.offsetX,
      onElementY: event.offsetY
    };
    this.designService.notifyBeginResize(this.notifier, ElementType.Text, horizontal, vertical, beginPoint);

    event.stopPropagation();
  }

  public onTitleResizing(event: MouseEvent) {
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY });
    }
    event.stopPropagation();
  }

  public onTableResizing(event: MouseEvent) {
    this.reportDataPlate.tableResize = true
    event.preventDefault();
    if (this.resizing) {
      this.designService.notifyResize(this.notifier, { onElementX: event.offsetX, onElementY: event.offsetY });
    }
    event.stopPropagation();
  }

  public onResizeMarkerUp(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    this.reportDataPlate.tableResize = false
    event.stopPropagation();
  }

  public onResizeMarkerLeave(event: MouseEvent) {
    event.preventDefault();
    this.resizing = false;
    this.reportDataPlate.tableResize = false
    event.stopPropagation();
  }
}
